import useTranslation from '@/hooks/useTranslation'
import { Box, Typography } from '@mui/material'

export const customSingleFlowSensor = (props: any) => {
  const { data, innerRef, innerProps } = props
  const { t } = useTranslation()
  return data ? (
    <Box
      ref={innerRef}
      {...innerProps}
      sx={{
        width: '100%',
        padding: '0 15px 20px 0',
        // background: '#f5f5f5',
        borderRadius: '5px',
        cursor: 'pointer',
      }}
    >
      <Typography variant="body2" sx={{ pb: 1.2 }}>
        <strong>{t('commonLabelsName')}:</strong> {data.io}
      </Typography>

      <Typography variant="body2">
        <strong>{t('formsLabelsAddress')}:</strong> {data.address}-{data.index}
      </Typography>
    </Box>
  ) : null
}

export const customOptionFlowSensor = (props: any) => {
  const { t } = useTranslation()
  const { data, innerRef, innerProps } = props
  return (
    <Box
      ref={innerRef}
      {...innerProps}
      sx={{
        padding: '8px',
        // background: '#f5f5f5',
        // marginBottom: "1px",
        borderRadius: '5px',
        cursor: 'pointer',
        paddingBottom: '15px',
        '&:hover': { background: '#e0e0e0' },
      }}
    >
      <Typography variant="body2" sx={{ pb: 1.2 }}>
        <strong>{t('commonLabelsName')}:</strong> {data.io}
      </Typography>

      <Typography variant="body2">
        <strong>{t('formsLabelsAddress')}:</strong> {data.address}-{data.index}
      </Typography>
    </Box>
  )
}

// For inline
export const customInlineSingleFlowValue = (props: any) => {
  const { data, innerRef, innerProps } = props

  return data ? (
    <Box
      ref={innerRef}
      {...innerProps}
      sx={{
        width: '100%',
        padding: '0 15px 10px 0',
        background: '#f5f5f5',
        borderRadius: '5px',
        cursor: 'pointer',
      }}
    >
      <Typography variant="body2" sx={{ pb: 1.1 }}>
        {data.io}
      </Typography>
    </Box>
  ) : null
}

export const customInlineSingleFlowSensor = (props: any) => {
  const { data, innerRef, innerProps } = props

  return data ? (
    <Box
      ref={innerRef}
      {...innerProps}
      sx={{
        width: '100%',
        padding: '0 15px 10px 0',
        background: '#f5f5f5',
        borderRadius: '5px',
        cursor: 'pointer',
      }}
    >
      <Typography variant="body2" sx={{ pb: 1.2 }}>
        {data.io}
      </Typography>
    </Box>
  ) : null
}

export const customInlineOptionFlowValveType = (props: any) => {
  const { data, innerRef, innerProps } = props
  return (
    <Box
      ref={innerRef}
      {...innerProps}
      sx={{
        padding: '8px',
        background: '#f5f5f5',
        borderRadius: '5px',
        cursor: 'pointer',
        '&:hover': { background: '#e0e0e0' },
      }}
    >
      <Typography variant="body2" sx={{ pb: 1.2 }}>
        {data.label}
      </Typography>
    </Box>
  )
}

export default {
  customSingleFlowSensor,
  customOptionFlowSensor,
  customInlineSingleFlowValue,
  customInlineSingleFlowSensor,
}
